import React, { useEffect, useState } from 'react';
import Search from './Search';
import Card from './Card';
import './Home.css';
import axios from 'axios';
import { devlogAPIURL } from '../APIurl';
import axiosClient from './axiosClient';
import CryptoJs from 'crypto-js';

const result = [
    { front: 'front', back: { id: '664efde5a7f118be5ff2d81c' }, previewImg: 'https://th.bing.com/th/id/OIP.XatquG04pMUw9hF8cP5ltQAAAA?rs=1&pid=ImgDetMain' },
    { front: 'front1', back: 'back', previewImg: 'https://th.bing.com/th/id/OIP.XatquG04pMUw9hF8cP5ltQAAAA?rs=1&pid=ImgDetMain' },
    { front: 'front2', back: 'back', previewImg: 'https://th.bing.com/th/id/OIP.XatquG04pMUw9hF8cP5ltQAAAA?rs=1&pid=ImgDetMain' },
    { front: 'front3', back: 'back', previewImg: 'https://th.bing.com/th/id/OIP.XatquG04pMUw9hF8cP5ltQAAAA?rs=1&pid=ImgDetMain' },
    { front: 'front4', back: 'back', previewImg: 'https://th.bing.com/th/id/OIP.XatquG04pMUw9hF8cP5ltQAAAA?rs=1&pid=ImgDetMain' },
    { front: 'front5', back: 'back', previewImg: 'https://th.bing.com/th/id/OIP.XatquG04pMUw9hF8cP5ltQAAAA?rs=1&pid=ImgDetMain' },
    { front: 'front5', back: 'back', previewImg: 'https://th.bing.com/th/id/OIP.XatquG04pMUw9hF8cP5ltQAAAA?rs=1&pid=ImgDetMain' },
    { front: 'front5', back: 'back', previewImg: 'https://th.bing.com/th/id/OIP.XatquG04pMUw9hF8cP5ltQAAAA?rs=1&pid=ImgDetMain' },
    { front: 'front5', back: 'back', previewImg: 'https://th.bing.com/th/id/OIP.XatquG04pMUw9hF8cP5ltQAAAA?rs=1&pid=ImgDetMain' },
    { front: 'front5', back: 'back', previewImg: 'https://th.bing.com/th/id/OIP.XatquG04pMUw9hF8cP5ltQAAAA?rs=1&pid=ImgDetMain' },
];

const Home = () => {
    const [results, setResults] = useState([]);
    const [filteredResults, setFilteredResults] = useState([]);

    useEffect(() => {
        (async function () {
            const a = await axiosClient.get(`${devlogAPIURL}/ankahiItems`);
       
            // console.log('response', letterItemsResp);
            const genItems = JSON.parse(CryptoJs.AES.decrypt(a.data.johSamajhnaHoSamajhLe, process.env.REACT_APP_SECRET_KEY).toString(CryptoJs.enc.Utf8));
            // console.log('decrypted', letterItems)
            //  console.log('sorted',letterItems.sort((i:any, j:any) => ((i.originalDate as string)).localeCompare((j.originalDate)) ))


            setResults(genItems.sort((i, j) => j.originalDate.localeCompare(i.originalDate) < 0));
            setFilteredResults(genItems.sort((i, j) => j.originalDate.localeCompare(i.originalDate) < 0));

        })();
    }, []);
    window.scrollTo(0, document.body.scrollHeight);

    const onSearch = (searchText) => {
        const filteredOnes = results.filter((i) => i.header?.toLowerCase().includes(searchText?.toLowerCase()) || i.body?.toLowerCase().includes(searchText?.toLowerCase()))
        setFilteredResults(filteredOnes);
    }

    return (
        <div className='home'>
            <div>
                <Search onSearch={onSearch} />
            </div>
            <h5 className='text-center'>This is sorted in descending order. Latest posts are on top.</h5>
            <div className="results d-flex flex-wrap">
                {
                    filteredResults.length > 0 ? filteredResults.reverse().map((item, i) => {
                        return <Card key={i} content={item} />
                    }) : <>...Loading</>
                }
            </div>
        </div>
    );
}

export default Home;

